var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!['coming-soon', 'robothon-registration'].includes(_vm.$route.name))?_c('HeaderNew'):_vm._e(),_c('router-view'),(['coming-soon', 'robothon-registration'].includes(_vm.$route.name))?_c('FooterRobothon'):_c('FooterNew'),_c('UANWidget')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }